import React, { useEffect, useState } from "react";
import Input from "../../components/controls/input/customInput/CustomInput";
import PhoneInput from "../../components/controls/input/phoneInput/PhoneInput";
import Style from "./Resources.module.css";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
import Searchable from "../../components/controls/select/CustomSelect";
import Button from "../../components/controls/button/Button";
import {
  languages,
  timezones,
  generateRandomString,
  calculatePageSize,
} from "../../helpers/utils";
import { AddIconSvg, ClockIcon, KeyIcon } from "../../modules/default-svg";
import service from "../../store/services/user.service";
import skillService from "../../store/services/skill.service";
import { checkEmail, checkPassword } from "../../utils/formValidation";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import Table from "../../components/controls/tables/Table";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import ModalCheckbox from "../../components/controls/modalcheckbox/ModalCheckbox";
import UserSelect from "../../components/userSelect/UserSelect";

const Resources = (props) => {
  const {
    allUsers,
    getUsersRequest,
    pageLoading,
    loading,
    createUserRequest,
    updateUserRequest,
    deleteUserRequest,
    pagination,
    error,
  } = props;
  const [data, setData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [perPageItems] = useState(calculatePageSize());
  const [selectedRow, setSelectedRow] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userName, setUserName] = useState("");
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhone] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [hourlyBillRate, setHourlyBillRate] = useState("");
  const [maxWeeklyHours, setMaxWeeklyHours] = useState("");
  const [operationalCapacity, setOperationalCapacity] = useState("");
  const [projectCapacity, setProjectCapacity] = useState("");
  const [language, setLanguage] = useState("");
  const [timezone, setTimezone] = useState("");
  const [responsibilities, setResponsibilities] = useState("");
  const [manager, setManager] = useState(null);
  const [roles, setRoles] = useState([]);
  const [isExternal, setIsExternal] = useState(false);
  // const [defaultRoleValues, setDefault] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);
  const [skills, setSkills] = useState([]);
  const [skillOptions, setSkillOptions] = useState([]);
  const [optionMessage, setOptionMessage] = useState("");
  const [formErrors, setFormErrors] = useState({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    userName: "",
    role: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [tableSearch, setTableSearch] = useState(null);
  const permissions = localStorage.getItem("permissions");
  const handleGeneratePassword = () => {
    const randomString = generateRandomString();
    setPassword(randomString);
  };

  const handleDelete = (selectedRow) => {
    if (!isDisable) {
      const id = selectedRow.id;
      deleteUserRequest({ id: id });
    }
  };

  const handleSave = () => {
    if (!isDisable) {

      const errors = {};
      if (!firstName) errors["firstName"] = `The FirstName field is required.`;
      if (!lastName) errors["lastName"] = `The LastName field is required.`;
      if (!userName) errors["userName"] = `The UserName field is required.`;
      if (!email) errors["email"] = `The Email field is required.`;

      if (checkEmail(email)) errors["email"] = checkEmail(email);

      if (password) {
        const passwordError = checkPassword(password);
        if (passwordError) errors["password"] = passwordError;
      }

      if (roles.length === 0) errors["role"] = `The Roles field is required.`;
      setFormErrors(errors);
      if (Object.keys(errors).length) {
        return;
      }

      const payload = {
        firstName,
        lastName,
        fullName: `${firstName} ${lastName}`,
        userName,
        title,
        email,
        phoneNumber,
        hourlyRate: hourlyRate,
        hourlyBillRate: hourlyBillRate,
        maxWeeklyHours,
        operationalCapacity,
        projectCapacity,
        language,
        timezone,
        responsibilities,
        managerId: manager?.id,
        roles: roles ? roles.map((role) => role.id) : [],
        skillsIds: skills ? skills.map((skill) => skill.id) : [],
        isExternal,
        password: password || null,
      };
      if (Object.keys(selectedRow).length > 0) {
        updateUserRequest({ id: selectedRow.id, payload });
      } else {
        createUserRequest({ payload });
      }
    }
  };

  useEffect(() => {
    if (error !== "") {
      setFormErrors({});
      error &&
        Object.keys(error).forEach((key) => {
          if (key === "FirstName") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              firstName: error[key][0],
            }));
          }
          if (key === "LastName") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              lastName: error[key][0],
            }));
          }
          if (key === "UserName") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              userName: error[key][0],
            }));
          }
          if (key === "Email") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              email: error[key][0],
            }));
          }
          if (key === "Password") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              password: error[key][0],
            }));
          }
        });
    } else {
      setFormErrors({});
    }
  }, [error]);

  useEffect(() => {
    if (firstName) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        firstName: "",
      }));
    }
    if (lastName) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        lastName: "",
      }));
    }
    if (userName) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        userName: "",
      }));
    }
    if (email) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
    if (password) {
      const passwordError = checkPassword(password);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        password: "",
        password: passwordError,
      }));
    }
    if (roles.length > 0) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        role: "",
      }));
    }
  }, [firstName, lastName, userName, email, roles, password]);

  const fetchUserData = async () => {
    setIsLoading(true);
    service
      .fetchSingleUserDataRequest(selectedRow.id)
      .then((userData) => {
        const settings = JSON.parse(localStorage.getItem("settings"));
        setFirstName(userData.firstName || "");
        setLastName(userData.lastName || "");
        setUserName(userData.userName || "");
        setTitle(userData.title || "");
        setEmail(userData.email);
        setEmail(userData.email || "");
        setPhone(userData.phoneNumber || "");
        setHourlyRate(userData.hourlyRate);
        setHourlyBillRate(userData.hourlyBillRate);
        setMaxWeeklyHours(userData.maxWeeklyHours);
        setOperationalCapacity(userData.operationalCapacity);
        setProjectCapacity(userData.projectCapacity);
        setLanguage(userData.language);
        setTimezone(userData.timezone);
        setResponsibilities(userData.responsibilities);
        setManager(userData.manager);
        const transformedArray = userData.roles && userData.roles.length > 0 ? userData.roles.map((obj) => ({
          label: obj.name,
          value: obj.id,
        })) : [];
        setRoleOptions(transformedArray);
        setRoles(userData.roles || []);
        const transformedSkillsArray = userData.skills && userData.skills.length > 0 ? userData.skills.map((obj) => ({
          label: obj.name,
          value: obj.id,
        })) : [];
        setSkillOptions(transformedSkillsArray);
        setSkills(userData.skills || []);
        setIsExternal(userData.isExternal);
        // setTimeout(() => {
        setIsLoading(false);
        // }, 3000);
      })
      .catch((error) => console.error("Error fetching user data:", error));
  };

  const handleCancel = () => {
    setFormErrors({});
    setPassword("");
    setIsEdit(false);
    setManager(null);
  };

  useEffect(() => {
    setPassword("");
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchUserData();
    } else {
      setFirstName("");
      setLastName("");
      setUserName("");
      setTitle("");
      setEmail("");
      setPhone("");
      setHourlyRate("");
      setHourlyBillRate("");
      setMaxWeeklyHours(40);
      setOperationalCapacity("");
      setProjectCapacity("");
      setLanguage("");
      setTimezone("");
      setResponsibilities("");
      setManager(null);
      setRoles([]);
      setSkills([]);
      setIsExternal(false);
    }
  }, [selectedRow, isEdit]);

  const handleInputChange = (value, name) => {
    if (name === "firstName") setFirstName(value);
    if (name === "lastName") setLastName(value);
    if (name === "userName") setUserName(value);
    if (name === "email") setEmail(value);
    if (name === "password") setPassword(value);
    if (name === "role") {
      const selectedRoles = value.map((val) => {
        const matchedRole = roleOptions.find((role) => role.value === val);
        return matchedRole ? { id: matchedRole.value, name: matchedRole.label } : null;
      }).filter(Boolean);

      setRoles(selectedRoles);
    }
    if (name === "skill") {
      const pool = [
        ...skills,
        ...skillOptions.map((o) => ({ id: o.value, name: o.label })),
      ];
      const selectedSkills = value
        .map((val) => pool.find((skill) => skill.id === val))
        .filter(Boolean);

      setSkills(selectedSkills);
    }
  };

  const searchRoleHandler = (value) => {
    service
      .searchRoleDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setRoleOptions(transformedArray);
        setOptionMessage("");
      })
      .catch((err) => {
        setRoleOptions([]);
        setOptionMessage("No result");
      });
  };

  const searchSkillHandler = (value) => {
    skillService
      .searchSkillsRequest(value)
      .then((res) => {
        const transformedArray = (res || []).map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setSkillOptions(transformedArray);
      })
      .catch(() => {
        setSkillOptions([]);
      });
  };

  const handleSkillCreated = (created) => {
    setSkills((prev) => [...prev, { id: created.value, name: created.label }]);
  };

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };


  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch = false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    getUsersRequest(payload);
  };
  useEffect(() => {
    if (allUsers && allUsers.length > 0) {
      if (pageNum === 1) {
        setData(
          allUsers
            .filter((item) => item.id !== deleteId)
            .sort((a, b) => {
              return b.isFlagged - a.isFlagged;
            })
        );
      } else {
        setData((prevData) => {
          const newMap = new Map(allUsers.map((item) => [item.id, item]));

          const updatedPrevData = prevData.map((item) =>
            newMap.has(item.id) ? newMap.get(item.id) : item
          );

          const prevDataIds = new Set(prevData.map((item) => item.id));
          const newItems = allUsers.filter(
            (shift) => !prevDataIds.has(shift.id)
          );

          return [...updatedPrevData, ...newItems]
            .filter((item) => item.id !== deleteId)
            .sort((a, b) => b.isFlagged - a.isFlagged);
        });
      }
    } else if (allUsers && allUsers.length === 0 && pageNum === 1) {
      setData([]);
    }
  }, [allUsers, deleteId, pageNum]);

  const validateEmail = (e) => {
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      email: checkEmail(e.target.value),
    }));
  };

  const formBody = () => {
    return (
      <>
        <h5 className="mb-4">General Info</h5>
        <div className={`d-flex align-items-center w-30 mb-3`}>
          <ModalCheckbox
            label={isExternal ? "External" : "Mark as External"}
            checked={isExternal}
            setChecked={setIsExternal}
          />
        </div>
        <div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={false}
              placeholder="Enter name"
              value={firstName}
              type="text"
              handleChange={(value) => handleInputChange(value, "firstName")}
              label="First name"
              cssClass={Style.inputField}
              errorMessage={formErrors.firstName}
              isRequired
              loading={isLoading}
            />
            <Input
              inputwd="w-50"
              icon={false}
              placeholder="Enter name"
              value={lastName}
              type="text"
              handleChange={(value) => handleInputChange(value, "lastName")}
              label="Last name"
              cssClass={Style.inputField}
              errorMessage={formErrors.lastName}
              isRequired
              loading={isLoading}
            />
          </div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={false}
              placeholder="Enter username"
              value={userName}
              type="text"
              handleChange={(value) => handleInputChange(value, "userName")}
              label="User name"
              cssClass={Style.inputField}
              errorMessage={formErrors.userName}
              isRequired
              loading={isLoading}
            />
            <Input
              inputwd="w-50"
              icon={false}
              placeholder="Enter title"
              value={title}
              type="text"
              handleChange={setTitle}
              label="Title"
              cssClass={Style.inputField}
              loading={isLoading}
            />
          </div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={false}
              placeholder="Enter email"
              value={email}
              type="email"
              handleChange={(value) => handleInputChange(value, "email")}
              handleBlur={(e) => validateEmail(e)}
              label="Email"
              cssClass={Style.inputField}
              errorMessage={formErrors.email}
              isRequired
              loading={isLoading}
            />
            <PhoneInput
              phoneWd="w-50"
              label="Phone Number"
              value={phoneNumber}
              handleChange={setPhone}
              placeholder="Enter phone"
              loading={isLoading}
            />
          </div>
          {permissions?.includes("User.Edit") && (
            <div className="d-flex align-items-start w-100 mb-32">
              <Input
                inputwd="w-49 me-3"
                icon={true}
                dir={true}
                autocomplete="new-password"
                placeholder="Enter password"
                value={password || ""}
                type="password"
                handleChange={(value) => handleInputChange(value, "password")}
                label="Password"
                cssClass={Style.inputField}
                errorMessage={formErrors.password}
                loading={isLoading}

              />
              <Button
                label="Generate password"
                icon={<KeyIcon />}
                btnClass="d_btn d_btn__whiteMd mt-25"
                clickHandler={handleGeneratePassword}
              />
            </div>
          )}
        </div>
        <h5 className="mb-4">Additional Information</h5>
        <div className="d-flex align-items-start w-100 mb-3">
          <UserSelect
            isAdminSearch={true}
            label="Manager"
            buttonLabel={"Select Manager"}
            value={manager}
            onChange={setManager}
            loading={isLoading}
          />
        </div>
        <div>
          <div className={`d-flex align-items-start w-100 mb-3`}>

            <Searchable
              label="Roles"
              SelectText="Role"
              selectWd="w-100"
              multiselect={true}
              searchText={searchRoleHandler}
              options={roleOptions}
              defaultVal={roles.map((role) => ({ label: role.name, value: role.id }))}
              onChange={(value) => handleInputChange(value, "role")}
              errorMessage={formErrors.role}
              optionMessage={optionMessage}
              isRequired
              loading={isLoading}
            />
          </div>
          <div className={`d-flex align-items-start w-100 mb-3`}>
            <Searchable
              label="Skills"
              SelectText="Skill"
              selectWd="w-100"
              multiselect={true}
              creatable={true}
              searchText={searchSkillHandler}
              options={skillOptions}
              defaultVal={skills.map((skill) => ({ label: skill.name, value: skill.id }))}
              onChange={(value) => handleInputChange(value, "skill")}
              createOptionRequest={(name) => skillService.createSkillRequest(name)}
              setCreated={handleSkillCreated}
              loading={isLoading}
            />
          </div>
          <div className="row align-items-start gx-3 mb-3">
            <div className="col-4">
              <Input
                inputwd=""
                value={hourlyRate}
                handleChange={setHourlyRate}
                label="Cost rate"
                placeholder="Enter hourly cost rate"
                rightStaticText={"/hour"}
                type="number"
                currency={true}
                loading={isLoading}
              />
            </div>
            <div className="col-4">
              <Input
                inputwd=""
                value={hourlyBillRate}
                handleChange={setHourlyBillRate}
                label="Bill rate"
                placeholder="Enter bill rate"
                rightStaticText={"/hour"}
                type="number"
                currency={true}
                loading={isLoading}
              />
            </div>
            <div className="col-4">
              <Input
                inputwd=""
                value={maxWeeklyHours}
                handleChange={setMaxWeeklyHours}
                label="Max hours"
                placeholder="Enter max hours"
                rightStaticText={"/week"}
                type="number"
                loading={isLoading}
              />
            </div>
          </div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={false}
              placeholder="Operational capacity"
              value={operationalCapacity}
              type="number"
              handleChange={setOperationalCapacity}
              label="Operational Weekly Capacity"
              rightStaticText={"%"}
              cssClass={Style.inputField}
              loading={isLoading}
            />
            <Input
              inputwd="w-50"
              icon={false}
              placeholder="Project capacity"
              value={projectCapacity}
              type="number"
              handleChange={setProjectCapacity}
              label="Project Weekly Capacity"
              rightStaticText={"%"}
              cssClass={Style.inputField}
              loading={isLoading}
            />
          </div>
          <div className={`d-flex align-items-start w-100 mb-3`}>
            <DropDown
              dropDownwd="w-50 me-3"
              label="Language"
              options={languages}
              defaultVal={language}
              onChange={setLanguage}
              loading={isLoading}
            />
            <DropDown
              dropDownwd="w-50"
              label="Time Zone"
              options={timezones}
              defaultVal={timezone}
              onChange={setTimezone}
              loading={isLoading}
            />
          </div>

          <div className={`d-flex align-items-start w-100 mb-3`}>
            <RichTextEditor
              label="Responsabilities"
              content={responsibilities}
              onChange={setResponsibilities}
              loading={isLoading}
              wrapperClass="w-100"
            />
          </div>
        </div>
      </>
    );
  };
  const [isCreate, setIsCreate] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  useEffect(() => {
    if (loading) setIsDisable(true);
    else setIsDisable(false);
  }, [loading]);

  const handleCreate = () => {
    setIsCreate(true);
  };
  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
      setPageNum(1);
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);

  };
  return (
    <ColumnConfigProvider tableName="Resource">
      <div className="listingScreen position-relative">
        <div className="db_Subheader d-flex justify-content-between align-items-center mb-4">
          <h4>Resources</h4>
          {permissions?.includes("Shift.Create") && (
            <Button
              btnClass="d_btn d_btn_primary"
              icon={<AddIconSvg />}
              label="Add Resource"
              clickHandler={handleCreate}
            />
          )}
        </div>

        <Table
          type="Resource"
          rows={data || []}
          searchHandler={handleSearch}
          body={formBody()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          setPageNum={setPageNum}
          setIsCreate={(status) => {
            setIsCreate(status);
          }}
          handleSave={() => handleSave()}
          handleDelete={(selectedRow) => handleDelete(selectedRow)}
          handleCancel={() => handleCancel()}
          setIsEdit={setIsEdit}
          setData={setData}
          loading={pageLoading}
          modalLoading={loading}
          isCreate={isCreate}
          pagination={pagination}
          setSelectedRow={setSelectedRow}
          handleRefresh={fetchData}
          triggerSearch={handleSearchTrigger}
        />
      </div>
    </ColumnConfigProvider>
  );
};

export default Resources;
